// Copyright (c) 2019 by Michael Marucheck
//
// Use of this source code is governed by an MIT-style license that
// can be found in the LICENSE file distributed with this file.

import * as Firebase from "firebase";

const firebase = (global as any).firebase as typeof Firebase;

const CRASHES = process.env.CRASH_COLLECTION || "crashes";

function crashes() {
  return firebase.firestore().collection(CRASHES);
}
function crash(timestamp: string) {
  return crashes().doc(timestamp);
}

export function logCrash(error: Error, info?: object) {
  const timestamp = new Date().toISOString();
  const user = firebase.auth().currentUser || { uid: "_", email: "_" };
  const message = (error && error.message) || "No error message";
  const uid = (user && user.uid) || "No uid";
  const email = (user && user.email) || "No email";
  crash(timestamp).set({ message, info: info || {}, uid, email });
}
